var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { autoinject, transient } from "aurelia-framework";
import { ChildComponent } from "../../../../pages/modules/child-component";
import { DataType, SourceType, QueryFilter } from "../../../../../models/queries/queries.models";
import * as Enumerable from "linq";
import { Guid } from "../../../../../utilities/guid";
import { DateTimeHelper } from "../../../../../helpers/date-time-helper";
import { NotificationClientService } from "../../../../../services/basics/notification-client.service";
import { QueriesClientService } from "../../../../../services/queries/queries-client.services";
import { I18N } from "aurelia-i18n";
import { EntityTypes } from "../../../../../models/basics/basics.models";
import { QueriesEditor } from "../../../../components/queries/queries-editor";
var PlayerChangeLog = /** @class */ (function (_super) {
    __extends(PlayerChangeLog, _super);
    function PlayerChangeLog(aureliaI18N, notificationClientService, queriesService) {
        var _this = _super.call(this, notificationClientService, aureliaI18N) || this;
        _this.queriesService = queriesService;
        return _this;
    }
    PlayerChangeLog.prototype.onBeforeSubmit = function () {
        return new Promise(function (resolve, reject) {
            resolve('');
        });
    };
    PlayerChangeLog.prototype.onItemChanged = function () {
        var _this = this;
        this.queriesService.getEntityModels().then(function (x) {
            var e_1, _a;
            var selectedModel = Enumerable.from(x)
                .firstOrDefault(function (x) { return x.name.toLowerCase() === "audits"; });
            var guid = Guid.generateGuid();
            var columns = [];
            try {
                for (var _b = __values(selectedModel.projectionProperties), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    var column = QueriesEditor.generateDefaultColumn(item, selectedModel);
                    if (item.type == DataType.Date) {
                        column.valueConverter = function (x) { return DateTimeHelper.getDateFormatted(x); };
                    }
                    columns.push(column);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            _this.itemSource = {
                sourceType: SourceType.ODataUrl,
                columns: columns,
                initialFilters: [
                    QueryFilter.getQuery("recordType", EntityTypes.Player, "eq", DataType.Number, true, false, guid, true),
                    QueryFilter.getQuery("recordId", (_this.item ? _this.item.gamePlayerId.toString() : '0'), "{0} eq '{1}'", DataType.Default, true, true, guid, true, true)
                ],
                groupInitialFilters: true,
                source: "/odata/Audits"
            };
        });
    };
    PlayerChangeLog.prototype.reload = function (self) {
        this.onItemChanged();
    };
    PlayerChangeLog = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [I18N, NotificationClientService, QueriesClientService])
    ], PlayerChangeLog);
    return PlayerChangeLog;
}(ChildComponent));
export { PlayerChangeLog };
